<template>
  <div>
    <v-card :loading="loadIa" outlined height="700">
      <!-- Top Toolbar -->
      <v-toolbar v-if="!modoSimples || mostrarModelos" flat dense>
        <v-btn v-if="!modoSimples" :disabled="isUltimoProntuario" :loading="loadProntuario" outlined class="mr-2 action-button"
          @click="copiarUltimoProntuario">
          <v-icon left small>mdi-content-copy</v-icon>
          <span class="button-text">Copiar último prontuário</span>
        </v-btn>

        <v-spacer></v-spacer>

        <v-toolbar-items class="d-flex align-center">
          <v-autocomplete v-model="modelo" :items="modeloProntuario.modelos" dense outlined
            hide-no-data hide-selected item-text="nome" item-value="_id" label="Buscar Modelos"
            placeholder="Digite para buscar" prepend-icon="mdi-database-search" return-object
            class="mt-6"
            >
          </v-autocomplete>

          <v-menu        
            :close-on-content-click="false"
            offset-y
            open-on-hover
            dark
            open-delay="0"
            close-delay="80"
          >         
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">                              
                <v-btn color="red accent-1" icon small class="action-icon" @click="clear">
                  <v-icon>mdi-broom</v-icon>
                </v-btn>
              </div>
            </template>
            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
              <div style="font-size: 14px;">Remover modelo selecionado.</div>      
              <v-btn text small color="primary" @click="hintLimparModelo = true">Saiba mais</v-btn>
            </v-card>
          </v-menu>

          <v-menu        
            :close-on-content-click="false"
            offset-y
            open-on-hover
            dark
            open-delay="0"
            close-delay="80"
          >         
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                  <v-btn :disabled="content && content.length < 8" v-if="idMedelo == null" icon small color="blue darken-1"
                  class="action-icon" @click="dialogNovoModelo = true">
                  <v-icon>mdi-note-plus</v-icon>
                </v-btn>
              </div>
            </template>
            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
              <div style="font-size: 14px;">Criar um modelo personalizado.</div>      
              <v-btn text small color="primary" @click="hintBtnNovoModelo = true">Saiba mais</v-btn>
            </v-card>
          </v-menu>

          <v-menu        
            :close-on-content-click="false"
            offset-y
            open-on-hover
            dark
            open-delay="0"
            close-delay="80"
          >         
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn v-if="idMedelo != null" icon small :disabled="content && content.length < 8" color="teal darken-2" class="action-icon"
                  @click="dialogEditarModelo = true">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </template>
            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
              <div style="font-size: 14px;">Editar modelo selecionado.</div>      
              <!-- <v-btn text small color="primary" @click="hintBtnNovoModelo = true">Saiba mais</v-btn> -->
            </v-card>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>

      <!-- Editor Content -->
       <v-card flat height="600" style="overflow-y: auto;">
      <v-sheet min-height="65vh" rounded="lg" class="editor-sheet">
        <div class="pa-2">
          <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
            placeholder="Descrição …" />
        </div>
      </v-sheet>
      </v-card>

      <!-- Bottom Toolbar -->
      <v-toolbar v-if="!modoSimples" flat dense class="px-2">
        <v-spacer></v-spacer>
        <v-btn icon large readonly :loading="loadSocket" :color="!idProntuario ? 'blue' : 'green'" class="save-button" depressed>
          <v-icon left>{{ !idProntuario ? 'mdi-content-save-edit' : 'mdi-content-save' }}</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>

    <v-dialog v-if="!modoSimples || mostrarModelos" v-model="dialogNovoModelo" width="900">
      <v-card class="rounded-lg">        
        <v-card-title class="text-h5 white--text primary py-4">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Cadastrar novo modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="Titulo" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição …" />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text :loading="loadModelos" @click="dialogNovoModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" dark :loading="loadModelos" @click="cadastrarModeloProntuarioAtendimento"
            class="px-4" depressed>
            <v-icon left>mdi-content-save</v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="!modoSimples || mostrarModelos" v-model="dialogEditarModelo" width="800">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text teal darken-2 py-4">
          <v-icon left color="white">mdi-pencil-circle</v-icon>
          Editar modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="titulo" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-show="!isImprime" v-model="content" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição …" />
          </v-card>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="dialogEditarModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" dark @click="cadastrarModeloProntuarioAtendimento" class="px-4" depressed>
            <v-icon left>mdi-content-save-edit</v-icon>
            Salvar alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Hints Prontuário-->
    <v-dialog v-if="!modoSimples || mostrarModelos" v-model="hintLimparModelo" max-width="500px" >
      <v-card style="overflow-x:hidden;">
        <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
          Remover modelo selecionado.
          <v-spacer/>
          <v-btn icon @click="hintLimparModelo = false"><v-icon color="white">mdi-close</v-icon></v-btn>
        </v-toolbar>
         <v-card-text class="ma-1">
          Remove a seleção do modelo atual, permitindo preencher livremente sem modelo pré-definido. Útil quando deseja criar uma prescrição ou prontuário do zero.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="!modoSimples || mostrarModelos" v-model="hintBtnNovoModelo" max-width="500px" >
      <v-card style="overflow-x:hidden;">
        <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
          Criar um modelo personalizado.
          <v-spacer/>
          <v-btn icon @click="hintBtnNovoModelo = false"><v-icon color="white">mdi-close</v-icon></v-btn>
        </v-toolbar>
         <v-card-text class="ma-1">
          Permite criar um <b>novo modelo de prontuário</b>, que ficará disponível para uso nas próximas vezes. Isso ajuda a padronizar e acelerar os lançamentos futuros. 
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import gptService from '../../services/gpt.service'
import socketService from '../../services/socket.service'
import { getToken } from '../../store/auth'
import 'tiptap-vuetify/dist/main.css'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

export default {
  name: 'Editor',
  components: { TiptapVuetify },
  props: {
    paciente: Object,
    idLaudo: Number,
    isUltimoProntuario: Boolean,
    msgProntuario: String,
    idProntuario: null,
    conteudo: { type: String, default: '' },
    modoSimples: { type: Boolean, default: false },
    mostrarModelos: { type: Boolean, default: false }
  },
  data: () => ({
    isImprime: false,
    user: {},
    isDisabled: true,
    content: '',
    tituloModelo: '',
    modelos: [],
    dialogNovoModelo: false,
    dialogEditarModelo: false,
    idMedelo: null,
    loadModelos: false,
    modeloProntuario: { modelos: [] },
    loadProntuario: false,
    modelo: null,
    loadIa: false,
    loadSocket: false,
    dialog: false,
    socket: null, // Adicionado para Socket.IO
    debounceTimeout: null, // Adicionado para debounce
    extensions: [
      History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
      [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
    ],
    hintLimparModelo: false,
    hintBtnNovoModelo: false
  }),
  mounted () {
    this.user = this.$store.getters.usuario
    this.content = this.conteudo
    // this.listarModelosProntuario()
    if (!this.modoSimples || this.mostrarModelos) {
      this.buscarModeloProntuarioAtendimento()
    }
    if (!this.modoSimples) {
      // Inicializa o Socket.IO
      this.socket = io.connect(socketService.SOCKET_URL, {
        query: {
          token: getToken()
        }
      })

      // Configura os listeners do Socket.IO
      this.chamarSocket()
    }
  },
  methods: {
    clear () {
      this.manualName = ''
      this.modelo = null
      this.tituloModelo = ''
      this.idMedelo = null
    },
    cadastrarModeloProntuarioAtendimento () {
      this.loadProntuario = true
      const modeloReceituario = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.content,
        _id: this.idMedelo
      }
      medicoService.medico.cadastrarModeloProntuarioAtendimento(modeloReceituario).then((r) => {
        if (r.status == 200) {
          this.content = ''
          this.modelo = null
          this.tituloModelo = ''
        }
      }).finally(() => {
        this.loadProntuario = false
        this.dialogNovoModelo = false
        this.dialogEditarModelo = false
        this.idMedelo = null
        this.buscarModeloProntuarioAtendimento()
      })
    },
    buscarModeloProntuarioAtendimento () {
      medicoService.medico.buscarModeloProntuarioAtendimento(this.user.id).then((r) => {
        if (r.status == 200) {
          this.modeloProntuario = r.data
        }
      })
    },
    gerarMensagemComparecimento () {
      const hoje = new Date()
      const dataFormatada = hoje.toLocaleDateString('pt-BR')
      const horaFormatada = hoje.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      this.content += `${dataFormatada}, às ${horaFormatada}`
    },

    copiarUltimoProntuario () {
      this.loadProntuario = true
      medicoService.medico.retornarUltimoProntuarioOS(this.paciente.idOrdemServico)
        .then(({ status, data }) => {
          if (status === 200) this.content += data.prontuario
        })
        .finally(() => { this.loadProntuario = false })
    },

    listarModelosProntuario () {
      this.loadModelos = true
      medicoService.medico.listarModelosProntuario('PRONTUARIO', this.user.id, '')
        .then(({ status, data }) => {
          if (status === 200 && data.status !== 'error') this.modelos = data
        })
        .finally(() => { this.loadModelos = false })
    },

    adicionarModelo (item) {
      this.content += item.descricao
    },

    formatarProntuario () {
      this.loadIa = true
      const { nomePaciente, idade } = this.paciente
      gptService.formatarProntuario({
        texto: this.content,
        nomePaciente,
        idadePaciente: idade,
        medico: this.user.nome
      }).then(({ status, data }) => {
        if (status === 200) this.content = data.content
      }).finally(() => { this.loadIa = false })
    },

    salvarProntuario () {
      const service = this.idProntuario ? 'editarProntuario' : 'editarLaudo'
      const payload = {
        idProntuario: this.idProntuario,
        idLaudo: this.idLaudo,
        descricao: this.content
      }

      this.loadIa = true
      medicoService.medico[service](payload)
        .then(({ status }) => {
          if (status === 200) this.alert = 'Salvo com sucesso!'
        })
        .finally(() => {
          this.loadIa = false
          this.isDisabled = true
        })
    },

    imprimir () {
      this.$emit('imprimirTexto', this.content)
    },

    // Função de debounce
    debounce (func, wait) {
      return (...args) => {
        clearTimeout(this.debounceTimeout)
        this.debounceTimeout = setTimeout(() => func.apply(this, args), wait)
      }
    },

    // Configura os listeners do Socket.IO
    chamarSocket () {
      this.socket.on('respostaCadastroTexto', (response) => {
        this.loadSocket = true
        console.log('response: ', response)

        if (response.status == 'success') {
          this.idProntuario = response.message.id
          console.log(this.idProntuario)
          this.loadSocket = false
        }
      })

      this.socket.on('connect_error', () => {
        console.error('Erro de conexão com o Socket.IO')
      })

      this.socket.on('disconnect', () => {
        console.warn('Desconectado do Socket.IO')
      })
    }
  },
  watch: {
    conteudo (val) {
      if (val !== this.content) this.content = val || ''
    },
    content (newContent, oldContent) {
      this.$emit('conteudo', this.content)
      if (!this.modoSimples) {
        this.loadSocket = true
        if (newContent !== oldContent) {
          this.debounce(() => {
            // Emitir um evento via Socket.IO para salvar o prontuário
            this.socket.emit('escutarEventoTexto', {
              idProntuario: this.idProntuario,
              idEmpresa: this.user.idEmpresa,
              idUnidade: this.user.idUnidade,
              descricao: this.content,
              idPaciente: this.paciente && this.paciente.idPaciente,
              idUsuario: this.user.id,
              idExamesOS: this.paciente && this.paciente.idExamesos,
              tipo: 'PRONTUARIO'
            })
          }, 2000)() // Debounce de 2 segundos
        }
      }
    },
    modelo (val) {
      if (!val) return
      this.tituloModelo = val.nome
      this.idMedelo = val._id
      this.content = val.descricao
    },
    alert (val) {
      if (val) setTimeout(() => (this.alert = null), 5000)
    }
  }
}
</script>
